<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Add Room
    </button>

    <a-modal v-model="visible" title="Add new room" :width="this.settings['isMobileView'] ? 480 : 720">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Close</a-button>
        <a-button key="submit" type="primary" htmlType="submit" :loading="loading" @click="handleSubmit">Submit</a-button>
      </template>

      <a-form class="mb-4" :form="form">

        <div class="row">
          <div class="col-12 col-md-4">
            <a-form-item label="Select Hostel" required>
              <a-select
                size="default"
                v-model="selectedHostel"
                placeholder="Select Hostel"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleHostelBlocks"
                :filterOption="false"
                :defaultValue="undefined"
              >
                <a-select-option :value="0">
                  Select Hostel
                </a-select-option>
                <template v-for="item in hostel">
                  <a-select-option :key="item.id" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </template>
              </a-select>
            </a-form-item>
          </div>
          <div class="col-12 col-md-4">
            <a-spin :spinning="blockSpinning">
              <a-form-item label="Select Block" required>
                <a-select
                  size="default"
                  v-model="selectedBlock"
                  placeholder="Select Block"
                  optionFilterProp="children"
                  style="width: 100%"
                  :filterOption="false"
                  :defaultValue="undefined"
                  :disabled="!selectedHostel"
                >
                  <a-select-option :value="0">
                    Select Block
                  </a-select-option>
                  <template v-for="block in blocks">
                    <a-select-option :key="block.id" :value="block.id">
                      {{ block.name }}
                    </a-select-option>
                  </template>
                </a-select>
              </a-form-item>
            </a-spin>
          </div>
          <div class="col-12 col-md-4">
            <a-form-item label="Select Facility">
              <a-select
                placeholder="Select Facility"
                v-decorator="['facility_id', { rules: [{ required: true, message: 'Please select a facility!' } ] }]"
                @change="getfacilities"
              >
                <a-select-option v-for="facility in selectedFacility" :key="facility" :value="facility.id">{{ facility.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <a-form-item label="Room Number">
              <a-input
                placeholder="Room Number"
                v-decorator="['room_number', {rules: [{ required: true, message: 'Please input a room number!' }]}]"
              />
            </a-form-item>
          </div>
          <div class="col-12 col-md-6">
            <a-form-item label="Capacity">
              <a-input-number
                placeholder="Room Capacity"
                :min="1"
                v-decorator="['room_capacity',{rules: [{ required: true, message: 'Please input capacity!'}]}]"
                style="width: 100%"
              />
            </a-form-item>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <a-form-item label="Room Type">
              <a-select v-decorator="['type', { rules: [{ required: true, message: 'Room type is required!!' }] } ]" placeholder="Room Type">
                <a-select-option v-for="roomType in roomTypes" :value="roomType.value" :key="roomType.value">
                  {{ roomType.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <div class="col-12 col-md-6">
            <a-form-item label="Room Status">
              <a-select v-decorator="['status', { rules: [{ required: false, message: 'Room status is required!!' }] } ]" placeholder="Room Status">
                <a-select-option v-for="status in roomStatus" :value="status.value" :key="status.value">
                  {{ status.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>

        <a-form-item label="Description">
          <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['description']" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { roomTypes, roomStatus } from '@/services/globaldata'
export default {
  name: 'roomAddModal',
  props: {
    formVisible: { type: Boolean, require: true },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      hostel: [],
      blocks: [],
      selectedHostel: 0,
      selectedBlock: 0,
      selectedFacility: [],
      blockSpinning: false,
      roomTypes,
      roomStatus,
    }
  },
  mounted: function () {
    this.getHostels()
    this.getfacilities()
  },
  computed: {
    ...mapState(['settings', 'user']),
  },
  watch: {
    formVisible: function(n, o) {
      this.visible = n
    },
  },
  methods: {
    getHostels: function() {
      this.$http.get(`/api/hostel`)
        .then(({ data }) => {
          this.hostel = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleHostelBlocks(value) {
      this.selectedBlock = 0
      if (value !== null) {
        this.selectedHostel = value
        this.blockSpinning = true
        this.getBlocks(value)
      }
    },
    getBlocks: function(value) {
      this.$http.get(`/api/hostel/blocks/${value}`)
        .then(({ data }) => {
          this.blocks = data
          this.blockSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    getfacilities: function() {
      this.$http.get(`/api/hostel/facility/all`)
        .then(({ data }) => {
          this.selectedFacility = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    showModal() {
      this.visible = true
      this.getHostels()
      this.getBlocks()
      this.getfacilities()
    },
    handleCancel(e) {
      this.visible = false
    },
    handleSubmit(e) {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to add ${values.room_number}?`,
            content: `Click on the OK button to add the hostel!`,
            onOk: () => {
              this.$nprogress.start()
              this.$http
                .post('/api/hostel/room/add', {
                  hostel_id: this.selectedHostel,
                  block_id: this.selectedBlock,
                  facility_id: values.facility_id,
                  room_number: values.room_number,
                  capacity: values.room_capacity,
                  description: values.description,
                  type: values.type,
                  status: values.status,
                })
                .then((data) => {
                  this.visible = false
                  this.$emit('created')
                  this.form.resetFields()
                  this.$nprogress.done()
                  this.$notification['success']({
                    message: 'Block successfully added!',
                    description: `Block ${values.name} added successfully!`,
                  })
                })
                .catch(error => {
                  this.$nprogress.done()
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              console.log('Cancel')
            },
          })
        }
      })
    },
  },
}
</script>
